import { type DateErrorType, validSeparatorsRegex } from './constants'

export function getSeparatorCharacterFromString(str: string) {
	const match = str.match(validSeparatorsRegex)

	if (match) {
		return match[0]
	}
}

export function isStringOnlyDigits(str: string) {
	return /^\d+$/.test(str)
}

export function createDateErrorObject({ errorType, formattedDate }: {
	errorType: DateErrorType,
	formattedDate?: string
}): DateError {
	return {
		errorType: errorType,
		formattedDate: formattedDate,
		hasError: true,
	}
}

export function createDateInfoObject({ formattedDate }: { formattedDate: string }): DateInfo {
	return {
		formattedDate: formattedDate,
		hasError: false,
	}
}

export interface DateError {
	errorType: DateErrorType
	formattedDate?: string
	hasError: true
}

export interface DateInfo {
	formattedDate: string
	hasError: false
}
